<div id="openExtendsHotelInformation" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content" *ngIf="hotel != null">
      <div class="modal-header">
        <h5 class="modal-title mt-0" id="mySmallModalLabel">
          Detalle | <span class="text-danger bold">{{hotel.tradename}}</span>
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <app-loading-modal></app-loading-modal>
      <div class="modal-body">
        <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__background">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail position-relative">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Nombre</div>
                <div class="child-right">
                  {{hotel.tradename}}
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left bold">Ciudad</div>
                <div class="child-right">
                  {{hotel.citietouristic.description}}
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-lg-12 p-0">
          <div class="table-responsive">
            <table class="table mb-0 table-sm">
              <thead class="thead-default">
                <tr>
                  <th class="nowrap w-25 w-xs-auto">Habitación</th>
                  <th class="nowrap w-xs-auto">N° huesp.</th>
                  <th class="nowrap text-center w-15 w-xs-auto">Precio Corporativo</th>
                  <th class="nowrap text-center w-15 w-xs-auto">Precio Normal</th>
                  <th class="nowrap text-center w-15 w-xs-auto">Precio Temp. Alta</th>
                  <th class="text-left">Observación</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of detail_typesbedroom; let _index = index">
                  <td class="nowrap w-25 w-xs-auto">
                    {{item.description}}
                  </td>
                  <td class="w-10 w-xs-auto text-center">
                    {{item.number_guests}}
                  </td>
                  <td class="w-15 w-xs-auto text-center">
                    {{item.price_corporate}}
                  </td>
                  <td class="w-15 w-xs-auto text-center">
                    {{item.price_sale}}
                  </td>
                  <td class="w-15 w-xs-auto text-center">
                    {{item.price_high}}
                  </td>
                  <td>
                    {{item.observation}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal"
          (click)="close()">Cerrar</button>
      </div>
    </div>
  </div>
</div>
<app-bookings-detail-extends></app-bookings-detail-extends>
